import { useEffect, useState } from 'react'

const FAB_THRESHOLD = 480

export function useMarketingScrollChrome(enabled = true) {
  const [showScrollFab, setShowScrollFab] = useState(false)

  useEffect(() => {
    if (!enabled) {
      return
    }

    let ticking = false

    const update = () => {
      setShowScrollFab(window.scrollY > FAB_THRESHOLD)
      ticking = false
    }

    const onScroll = () => {
      if (ticking) return
      ticking = true
      requestAnimationFrame(update)
    }

    update()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [enabled])

  return {
    showScrollFab: enabled ? showScrollFab : false,
  }
}
